import { useState, useEffect } from 'react'

import { getChecklistNewStepAPI } from '../services/checklist'

function UseChecklistNewStep() {
  const [data, setData] = useState([])
  useEffect(() => {
    const getOrganization = async () => {
      const result = await getChecklistNewStepAPI()
      if (!result) return

      const newData = result.result.map((d, i) => {
        return { value: d.id, label: d.step_name }
      })

      setData(newData)
    }
    getOrganization()
  }, [])

  return data
}

export default UseChecklistNewStep
